import { ReactComponent as Icon } from "../icons/list2.svg";

const ListIcon = ({color, wth}) => {
  return (
    <div>
      <Icon style={({fill: color, width: wth, marginTop: "3px"})} />
    </div>
  );
};

export default ListIcon;